// FIXME: Reduce duplication of the vue boilerplate across files

import Vue from 'vue/dist/vue.esm'

import format from "../format"
import marked from "marked"

Vue.prototype.format = format
Vue.prototype.marked = marked

import { BootstrapVue, BootstrapVueIcons  } from 'bootstrap-vue'



Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

export default {
  setupVue(params) {
    document.addEventListener('DOMContentLoaded', () => {
      new Vue(params)
    })
    
  }
}